import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';

import { deleteCheckedDeclarations } from 'src/reducers/reports/incomeTaxDeclarations';

import styles from './BatchDeleteDeclarationModal.scss';

const BatchDeleteDeclarationModal = ({ isOpen, hideModal, checkedDeclarations = [], changeToShowMode }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await dispatch(deleteCheckedDeclarations({ checkedDeclarations, changeToShowMode, hideModal }));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <CommonModal.Header hideModal={hideModal}>{t('features.ReportIncomeTax.list.bulk_delete.title')}</CommonModal.Header>
      <CommonModal.Body>
        <div className={styles.cautionSection}>
          <span className={styles.warning}>{t('features.ReportIncomeTax.list.bulk_delete.caution_label')}</span>
        </div>
        <p className={styles.messageSection}>
          {t('features.ReportIncomeTax.list.bulk_delete.warning_message_part1')}
          <span className={styles.warning}>{t('features.ReportIncomeTax.list.bulk_delete.warning_message_part2')}</span>
          {t('features.ReportIncomeTax.list.bulk_delete.warning_message_part3')}
          <span className={styles.warning}>{t('features.ReportIncomeTax.list.bulk_delete.warning_message_part4')}</span>
          {t('features.ReportIncomeTax.list.bulk_delete.warning_message_part5')}
        </p>
        <div className={styles.confirmSection}>
          <span className={styles.importantWarning}>{t('features.ReportIncomeTax.list.bulk_delete.confirm_question')}</span>
        </div>
        {t('features.ReportIncomeTax.list.bulk_delete.items_label')}
        <div>
          <ul>
            {checkedDeclarations.map(declaration => (
              <li key={declaration.id}>
                ・{declaration.declarationName} ({declaration.periodMonth || `Q${declaration.periodQuarter}`}/{declaration.periodYear})
              </li>
            ))}
          </ul>
        </div>
      </CommonModal.Body>
      <CommonModal.Footer>
        <CommonModal.Buttons>
          <Button primary onClick={handleConfirm} disabled={isSubmitting}>
            {isSubmitting ? t('common.processing') : t('features.ReportIncomeTax.list.bulk_delete.confirm')}
          </Button>
          <Button onClick={hideModal} disabled={isSubmitting}>
            {t('features.ReportIncomeTax.list.bulk_delete.cancel')}
          </Button>
        </CommonModal.Buttons>
      </CommonModal.Footer>
    </CommonModal>
  );
};

export default BatchDeleteDeclarationModal;
